<div *ngIf="hasDescriptions()" class="lqd-column col-md-12">
  <app-step-description *ngFor="let stepDescription of stepsDescription" [description]="stepDescription"></app-step-description>
</div>
